// ----------------------------------------------------------------------
// <copyright file="Izenda.FormBorderSettings.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Form Border Settings component
 */
!(function() {
  var React = require('react');
  var EventsUtils = require('EventUtils');
  var observer = require('mobx-react').observer;
  var Thinkness = require('share/components/controls/Izenda.Thinkness');
  var ColorPicker = require('share/components/controls/Izenda.ColorPicker');
  var DashStyle = require('share/components/controls/Izenda.DashStyle');
  var Input = require('share/components/controls/Izenda.Input');
  var localizer = require('share/localization/Izenda.Localizer');
  var AppGlobal = require('Izenda.AppGlobal');

  var FormBorderSettings = React.createClass({
    propTypes: {
      onChange: React.PropTypes.func
    },

    getInitialState: function() {
      var value = this.props.value;
      return {
        isVisibleBorder: value.isVisibleBorder,
        borderStyle: value.borderStyle,
        borderColor: value.borderColor,
        borderWidth: value.borderWidth
      };
    },

    // Return data for update data.
    getValue: function() {
      var state = this.state;
      return {
        isVisibleBorder: state.isVisibleBorder,
        borderStyle: state.borderStyle,
        borderColor: state.borderColor,
        borderWidth: state.borderWidth
      };
    },

    onChange: function(key, value) {
      var newState = {};
      newState[key] = value;
      this.setState(newState);
    },

    render: function() {
      var state = this.state;
      var notifyChange = EventsUtils.notifyChange;
      var formStyles = state.isVisibleBorder
        ? {
            borderStyle: state.borderStyle,
            borderColor: state.borderColor,
            borderWidth: state.borderWidth
          }
        : null;
      var configurationClass = AppGlobal.canShowPreview() ? 'col-md-6' : 'col-md-12';

      return (
        <section className='border-settings'>
          <div className='row no-margin border-settings-header'>
            <div className={`${configurationClass} text-center`}>{localizer.getText('COMMON_LABEL_CONFIGURATION')}</div>
            {AppGlobal.canShowPreview() && (
              <div className='col-md-6 text-center'>{localizer.getText('COMMON_LABEL_PREVIEW')}</div>
            )}
          </div>
          <div className='row no-gutter no-margin border-settings-body flex-layout'>
            <div className={`${configurationClass} text-center form-horizontal`}>
              <div className='form-group'>
                <label className='control-label col-md-4'>{localizer.getText('COMMON_LABEL_VISIBLE')}</label>
                <div className='col-md-8 text-left'>
                  <Input
                    className='default'
                    type='checkbox'
                    checked={!!state.isVisibleBorder}
                    onChange={notifyChange(handleOnChange.bind(this, 'isVisibleBorder'), EventsUtils.CHECKBOX)}
                  />
                </div>
              </div>
              <div className='form-group'>
                <label className='control-label col-md-4'>{localizer.getText('BORDER_SETTING_LABEL_DASH_STYLE')}</label>
                <div className='col-md-8'>
                  <DashStyle
                    disabled={!state.isVisibleBorder}
                    dashStyle={state.borderStyle}
                    onChange={handleOnChange.bind(this, 'borderStyle')}
                  />
                </div>
              </div>
              <div className='form-group'>
                <label className='control-label col-md-4' aria-middle='true'>
                  {localizer.getText('COMMON_LABEL_COLOR')}
                </label>
                <div className='col-md-8 text-left'>
                  <div className='borders-color'>
                    <ColorPicker
                      disabled={!state.isVisibleBorder}
                      color={state.borderColor}
                      onChange={handleOnChange.bind(this, 'borderColor')}
                    />
                  </div>
                </div>
              </div>

              <div className='form-group'>
                <label className='control-label col-md-4' aria-middle='true'>
                  {localizer.getText('BORDER_SETTING_LABEL_THICKNESS')}
                </label>
                <div className='col-md-8'>
                  <Thinkness
                    disabled={!state.isVisibleBorder}
                    value={state.borderWidth}
                    onChange={handleOnChange.bind(this, 'borderWidth')}
                  />
                </div>
              </div>
            </div>
            {AppGlobal.canShowPreview() && (
              <div className='col-md-6 text-center'>
                <div className='full-height' style={formStyles}>
                  {localizer.getText('REPORTDESIGNER_PLACEHOLDER_DUMMY_REPORT_PART_FORM')}
                </div>
              </div>
            )}
          </div>
        </section>
      );

      function handleOnChange(value) {
        var argValue = value === 'borderWidth' ? arguments[1].value : arguments[1];
        this.onChange.call(this, arguments[0], argValue);
      }
    }
  });
  module.exports = observer(FormBorderSettings);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.FormBorderSettings.jsx